import React, { Component } from "react";
import { injectIntl, IntlShape } from "@ai360/core/intl";

import { DataTable } from "~/core";
import { withCrud } from "~/hocs";
import { FormattingHelpers } from "@ai360/core";
import { memoizeFormattedRecords } from "~/admin/utils";

import { service, actions } from "./log-data";
import { messages } from "../i18n-messages";

interface IEquipmentLogProps {
    records?: Record<string, unknown>[];
    intl: IntlShape;
}

export class EquipmentLog_ extends Component<IEquipmentLogProps> {
    getFormattedRecords = memoizeFormattedRecords(FormattingHelpers.formatLogDetailText);
    render(): JSX.Element {
        return (
            <div>
                <DataTable
                    service={service}
                    isCheckbox={false}
                    showFilterInput={false}
                    messages={messages}
                    {...this.props}
                    records={this.getFormattedRecords(this.props.records)}
                />
            </div>
        );
    }
}
export const EquipmentLog = injectIntl(withCrud(EquipmentLog_, service, actions));
